export const VOLUNTEER_WILL_PREFIX = 'Volunteer will ';
